import React from 'react';
import classNames from 'classnames';
import { sortBy } from 'lodash';
import { Icon } from 'ui';
import SmartGroupsList from './SmartGroupsList';

class SmartGroups extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: true,
    };
    this.toggleExpand = this.toggleExpand.bind(this);
  }

  toggleExpand() {
    this.setState(state => ({
      expanded: !state.expanded,
    }));
  }

  render() {
    const {
      groups,
      activeGroup,
      updateActiveGroup,
      updateMyOrganization,
      createNewRuleBasedGroup,
      canEditSmartGroups,
      toggleGroupsList,
      groupsListVisible,
    } = this.props;
    const hasGroups = groups.length > 0;
    const hasNoGroups = groups.length === 0;
    const notExpandedAndHasNoGroups = hasNoGroups && !this.state.expanded;
    const showIcon = hasGroups || notExpandedAndHasNoGroups;
    const iconStyle = classNames({
      'NestedList-icon': true,
      'mr-4': true,
      'NestedList-icon--rotated': this.state.expanded,
    });

    return (
      <div className="SmartGroups mt-16">
        <div className="NestedList-header">
          <div className="fw-b">
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
            <span className={iconStyle} onClick={this.toggleExpand}>
              <Icon
                name="triangle_down"
                className="Icon--small c-brand-gray c-p"
              />
            </span>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
            <span className="mr-4 c-p" onClick={this.toggleExpand}>
              {t('smart_groups.name')}
            </span>
            {showIcon && (
              <span
                className="h-ci"
                data-toggle="tooltip"
                title={t('smart_groups.description')}
                data-placement="top"
              >
                <Icon
                  name="info"
                  className="NestedList-headerIcon c-brand-gray"
                />
              </span>
            )}
          </div>
          {showIcon && canEditSmartGroups && (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
              className="ButtonWithTooltip fz-base c-p"
              data-tooltip={t('smart_groups.new')}
            >
              <div>
                <Icon
                  name="add"
                  className="NestedList-headerIcon c-brand-gray fz-bigger"
                  onClick={createNewRuleBasedGroup}
                />
              </div>
            </a>
          )}
        </div>
        {this.state.expanded && (
          <div>
            {hasNoGroups && (
              <div className="NestedList-item">
                <div className="mb-8 c-brand-gray-dark">
                  {t('smart_groups.description')}
                </div>
                {canEditSmartGroups && (
                  <button
                    type="button"
                    className="NewButton NewButton--white mb-8"
                    onClick={createNewRuleBasedGroup}
                  >
                    <Icon name="add" className="c-brand-gray-dark mr-4" />
                    {t('smart_groups.new')}
                  </button>
                )}
              </div>
            )}
            <ul>
              {sortBy(groups, 'name').map(group => (
                <SmartGroupsList
                  group={group}
                  key={group.id}
                  activeGroup={activeGroup}
                  updateActiveGroup={updateActiveGroup}
                  updateMyOrganization={updateMyOrganization}
                  toggleGroupsList={toggleGroupsList}
                  groupsListVisible={groupsListVisible}
                />
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

export default SmartGroups;
